<template>
  <div>
    <div class="row row-spacing">
      <div class="form-group col-md-6" v-allowed:view="['STAFF']">
        <button type="button" class="btn btn-sm btn-primary mt-2" v-tooltip="'Add Markup'" @click="openWholesaleModal()">
          <i class="fa-solid fa-plus"></i> New Wholesale Markup
        </button>
      </div> 
    </div>
    <hr>
    <div class="card-scroll-90 mt-2">
      <div class="row">
        <div class="col-md-12">
          <div class="card table-responsive">
            <table class="table table-hover table-bordered" v-if="isLoaded === true">
              <thead>
                <tr>
                  <th @click="sortBy('productNumber')">Product
                    <i class="fa fa-sort-asc float-right" v-if="sortKey == 'productNumber' && reverse"></i>
                    <i class="fa fa-sort-desc float-right" v-if="sortKey == 'productNumber' && !reverse"></i>
                  </th>
                  <th @click="sortBy('nrcMmarkupPercentage')">NRC Markup %
                    <i class="fa fa-sort-asc float-right" v-if="sortKey == 'nrcMmarkupPercentage' && reverse"></i>
                    <i class="fa fa-sort-desc float-right" v-if="sortKey == 'nrcMmarkupPercentage' && !reverse"></i>
                  </th>
                  <th @click="sortBy('mrcMmarkupPercentage')">MRC Markup %
                    <i class="fa fa-sort-asc float-right" v-if="sortKey == 'mrcMmarkupPercentage' && reverse"></i>
                    <i class="fa fa-sort-desc float-right" v-if="sortKey == 'mrcMmarkupPercentage' && !reverse"></i>
                  </th>
                  <th v-allowed:view="['STAFF']"></th>
                </tr>
              </thead>
              <tbody v-if="filteredWholesales.length > 0">
                <tr
                  v-for="whole in filteredWholesales"
                  :key="whole.wholesaleMarkupNumber"
                >
                  <td>{{ getProductDesc(whole.productNumber) }}</td>
                  <td>{{ whole.nrcMmarkupPercentage }}%</td>
                  <td>{{ whole.mrcMmarkupPercentage }}%</td>
                  <td class="text-center" v-allowed:view="['STAFF']">
                    <button class="btn btn-info" v-tooltip="'Edit Config'" @click="editWholesale(whole)"><i class="fa-solid fa-pencil"></i></button>
                    <button type="button" class="btn btn-sm btn-primary" v-tooltip="'Remove Config'" @click="removeWholesale(whole.wholesaleMarkupNumber)"><em class="fa fa-trash fa-fw"></em></button>
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="7">No wholesale markup found</td>
                </tr>
              </tbody>
            </table>
            <div v-else-if="isLoaded === false">
              <DataLoader 
                :loadingText="'Loading Wholesale Markups...'"
                style="min-height: 300px"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal
      :title="
        selectedWhole.wholesaleMarkupNumber ? 'Edit Wholesale Markup' : 'Add New Wholesale Markup'
      "
      ref="modifyWholesale"
      size="modal-lg"
      @save="selectedWhole.wholesaleMarkupNumber ? updateWholesale() : createWholesale()"
    >
      <div class="row">
        <div class="form-group col-md-10">
          <label class="control-label"> Product </label>
          <select
            class="form-control"
            v-model="selectedWhole.productNumber"
          >
            <option
              v-for="product in wholesaleProducts"
              :key="product.productNumber"
              :value="product.productNumber"
            >
              {{ product.description }}
            </option>
          </select>
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-10">
          <label class="control-label"> NRC Markup % </label>
          <input
            type="text"
            class="form-control"
            v-model="selectedWhole.nrcMmarkupPercentage"
          />
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-10">
          <label class="control-label"> MRC Markup % </label>
          <input
            type="text"
            class="form-control"
            v-model="selectedWhole.mrcMmarkupPercentage"
          />
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import DataLoader from "@/components/GeneralComponents/DataLoader";
import Modal from "@/components/GeneralComponents/Modal";

export default {
  components: {
      DataLoader,
      Modal
  },
  data() {
    return {
      isLoaded: false,
      clientNumber: null,
      wholesale: [],
      wholesaleProducts: [],
      client: [],

      selectedWhole: {},
      newWholesale: {
        class: "za.co.adept.aims.billing.WholesaleMarkup",
        wholesaleMarkupNumber: 0,
        clientNumber: this.$route.params.clientNumber,
        productNumber: 0,
        nrcMmarkupPercentage: 0,
        mrcMmarkupPercentage: 0,
      },

      sortKey: 'productNumber',
      reverse: false,
    };
  },
  created() {  
    document.title = this.$route.params.clientNumber + " - Wholesale Markup";
  },
  mounted() {
    this.clientNumber = this.$route.params.clientNumber;
    if (this.userContainsPermission(["CLIENT"])) {
        this.$root.$emit("SET_CLIENT_PAGE_TITLE", "Wholesale Markup"); 
    }
    this.getWholesaleProducts();
    this.getWholesaleForClient();
  },
  computed: {
    filteredWholesales: function() {
      if (this.reverse) {
        return _.orderBy(this.wholesale, this.sortKey, 'asc');
      } else {
        return _.orderBy(this.wholesale, this.sortKey, 'desc');
      }
    }
  },
  methods: {
    getWholesaleProducts: function() {
      this.isLoaded = false; 
      const hostUrl = this.$config.aimsAPI;

      this.$http.get(`${hostUrl}products?wholesale=true`).then(
          (response) => {
            this.wholesaleProducts = response.data;
            this.isLoaded = true; 
          },
          (error) => {
            console.error(error);
            this.showError("Error Fetching Wholesale Products", error);
            this.isLoaded = true; 
          }
      );
    },
    getWholesaleForClient: function() {
      this.isLoaded = false; 
      const hostUrl = this.$config.aimsAPIv2;

      this.$http.get(`${hostUrl}wholesale/client/${this.clientNumber}`).then(
          (response) => {
            this.wholesale = response.data;
            this.isLoaded = true; 
          },
          (error) => {
            console.error(error);
            this.showError("Error Fetching Wholesale Markup", error);
            this.isLoaded = true; 
          }
      );
    },
    openWholesaleModal() {
      this.selectedWhole = this.deepCopyObject(this.newWholesale);
      this.$refs.modifyWholesale.open();
    },
    editWholesale(wholesale) {
      this.selectedWhole = this.deepCopyObject(wholesale);
      this.$refs.modifyWholesale.open();
    },
    createWholesale() {
      this.$http.post(this.$config.aimsAPIv2 + "wholesale/create", this.selectedWhole)
        .then((response) => {
            this.selectedWhole = {};
            this.showSuccess("Saved Wholesale Markup");
            this.$refs.modifyWholesale.close();
            this.getWholesaleForClient();
          }, (error) => {
            console.error(error);
            this.showError("Error Fetching Wholesale Markup", error);
        });
    },
    updateWholesale() {
      this.$http.put(this.$config.aimsAPIv2 + "wholesale/update", this.selectedWhole)
        .then((response) => {
            this.selectedWhole = {};
            this.showSuccess("Saved Wholesale Markup");
            this.$refs.modifyWholesale.close();
            this.getWholesaleForClient();
          }, (error) => {
            console.error(error);
            this.showError("Error Fetching Wholesale Markup", error);
        });
    },
    removeWholesale(wholesaleNumber) {
      this.$swal({
        title: "Are you sure you want to delete this Wholesale Markup?",
        type: "warning",
        showCancelButton: true,
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes",
      }).then((result) => {
          if (result.value) {
            this.isLoaded = false; 
            const hostUrl = this.$config.aimsAPIv2;
            this.$http.delete(`${hostUrl}wholesale/delete/${wholesaleNumber}`).then(
              (response) => {
                this.wholesale = response.data;
                this.getWholesaleForClient();
              }, (error) => {
                console.error(error);
                this.showError("Error Fetching Wholesale Markup", error);
                this.isLoaded = true; 
              }
            );
          }
        }
      )
    },
    getProductDesc(productNumber) {
      const product = this.wholesaleProducts.find((p) => p.productNumber === productNumber);
      return product ? product.description : "Product not found";
    },
    sortBy(sortKey) {
      this.reverse = (this.sortKey == sortKey) ? ! this.reverse : false;
      this.sortKey = sortKey;
    },
  },
};
</script>

<style scoped>
.highlight > .badge {
  transform: scale(1.2);
  border: 1px grey solid;
}

th:hover {
  cursor:pointer;
}

.table>thead>tr>th {
  padding: 1em;
  background-color: #3a3f51;
  color: #FFFFFF; 

  position: sticky;
  top: 0;
  z-index: 2;
} 

.pull-right {
  float: right;
}
</style>
